import React from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import { ICurrency } from './types';

type TransactionsFiltersPropsTypes = {
  values: {
    from: string;
    to: string;
    accountId: string;
    trxId: string;
    currencies: string;
  };
  handleSubmit: () => void;
  setFieldValue: (field: string, value: any) => void;
  loading: boolean;
  availableCurrencies?: ICurrency[];
};

const TransactionsFilters = (props: TransactionsFiltersPropsTypes) => {
  const {
    values: {
      from = '',
      to = '',
      accountId = '',
      trxId = '',
      currencies: currenciesValue = ''
    } = {},
    handleSubmit,
    setFieldValue,
    loading,
    availableCurrencies = []
  } = props;

  return (
    <div className="row g-2 align-items-end">
      <div className="col-12 col-md-3">
        <Form.Label className="small fw-semibold mb-1">Номер счёта</Form.Label>
        <Form.Control
          size="sm"
          name="accountId"
          type="search"
          value={accountId}
          onChange={e => setFieldValue('accountId', e.target.value)}
          placeholder="Введите номер счёта"
          disabled={loading}
        />
      </div>
      <div className="col-12 col-md-3">
        <Form.Label className="small fw-semibold mb-1">ID транзакции</Form.Label>
        <Form.Control
          size="sm"
          name="trxId"
          type="search"
          value={trxId}
          onChange={e => setFieldValue('trxId', e.target.value)}
          placeholder="Введите ID транзакции"
          disabled={loading}
        />
      </div>
      <div className="col-12 col-md-2">
        <Form.Label className="small fw-semibold mb-1">Валюта</Form.Label>
        <Select
          closeMenuOnSelect={false}
          options={availableCurrencies as any}
          placeholder="Все"
          isMulti
          isDisabled={loading}
          styles={{
            control: base => ({ ...base, minHeight: '31px', fontSize: '0.875rem' }),
            valueContainer: base => ({ ...base, padding: '0 6px' }),
            dropdownIndicator: base => ({ ...base, padding: '4px' }),
          }}
          classNamePrefix="react-select"
          value={currenciesValue}
          onChange={value => setFieldValue('currencies', value)}
        />
      </div>
      <div className="col-6 col-md-2">
        <Form.Label className="small fw-semibold mb-1">Дата с</Form.Label>
        <ReactDatePicker
          popperPlacement="bottom-start"
          selected={from as any}
          onChange={date => setFieldValue('from', date)}
          formatWeekDay={day => day.slice(0, 3)}
          className="form-control form-control-sm"
          disabled={loading}
          placeholderText="дд.мм.гггг"
        />
      </div>
      <div className="col-6 col-md-2">
        <Form.Label className="small fw-semibold mb-1">Дата по</Form.Label>
        <ReactDatePicker
          popperPlacement="bottom-start"
          selected={to as any}
          onChange={date => setFieldValue('to', date)}
          formatWeekDay={day => day.slice(0, 3)}
          className="form-control form-control-sm"
          disabled={loading}
          placeholderText="дд.мм.гггг"
        />
      </div>
      <div className="col-12 col-md-auto">
        <Button
          variant="primary"
          size="sm"
          disabled={loading}
          onClick={handleSubmit}
          className="d-flex align-items-center gap-2"
        >
          Поиск
          {loading && (
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default TransactionsFilters;
